import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import type { IFormElement } from '../types';
import { useFormState } from '../contexts/FormStateContext';
import styles from './fields.module.css';

export interface NumberFieldProps {
  element: IFormElement;
  questionNumber?: number;
}

export const NumberField: React.FC<NumberFieldProps> = ({
  element,
  questionNumber,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const formState = useFormState();
  const error = errors[element.name];
  const validationError = formState.validationErrors[element.name];

  const renderLabel = () => {
    if (!element.title) return null;
    return (
      <label
        className={`${styles.label} ${
          element.isRequired ? styles.required : ''
        }`}
        htmlFor={element.name}
      >
        {questionNumber && (
          <span className={styles.questionNumber}>{questionNumber}. </span>
        )}
        {element.title}
      </label>
    );
  };

  return (
    <div className={styles.formField}>
      {renderLabel()}
      {element.description && (
        <p className={styles.description}>{element.description}</p>
      )}
      <Controller
        name={element.name}
        control={control}
        defaultValue={element.defaultValue || ''}
        render={({ field }) => (
          <input
            {...field}
            id={element.name}
            type="number"
            className={`${styles.input} ${
              error || validationError ? styles.error : ''
            }`}
            placeholder={element.placeholder || ''}
            disabled={element.readOnly}
            min={element.min}
            max={element.max}
            step={element.step || 1}
            onChange={(e) => {
              const value = e.target.value === '' ? '' : Number(e.target.value);
              field.onChange(value);
              if (validationError) {
                formState.clearValidationError(element.name);
              }
            }}
            onBlur={() => {
              field.onBlur();
              formState.markFieldAsTouched(element.name);
            }}
          />
        )}
      />
      {(error || validationError) && (
        <p className={styles.errorMessage}>
          {(error?.message as string) || validationError}
        </p>
      )}
    </div>
  );
};

export default NumberField;
